import { create } from 'zustand'

interface IAudioStore {
    isPlaying: boolean
    play: () => void
    stop: () => void
}

export const useAudioStore = create<IAudioStore>((set) => ({
    isPlaying: false,
    play: () => set({ isPlaying: true }),
    stop: () => set({ isPlaying: false })
}))
